export default __webpack_public_path__ + "static/media/likeUnselectedLavander.22651f33.svg";